<template>
  <div id="contenedor-contrato-insumos-tool-bar">
    <v-toolbar flat dense>
      <v-spacer></v-spacer>
      <v-menu v-if="!soloLectura" bottom left offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              class="mr-2">
              <v-icon>
                mdi-cog-outline
              </v-icon>
            </v-btn>
          </template>
          <v-list dense nav>
            <v-list-item
            @click="$emit('abrirTiposArchivos')">
            <v-list-item-icon class="mr-0">
              <v-icon small>
                mdi-file-multiple-outline
              </v-icon>
            </v-list-item-icon>
              <v-list-item-title>
                Tipos de Archivos
              </v-list-item-title>
            </v-list-item>
          </v-list>
      </v-menu>
      <v-btn
        v-if="!soloLectura"
        color="primary"
        rounded
        @click="agregarArchivo">
        <v-icon left small>
          mdi-plus
        </v-icon>
        Aregar archivo
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ContratoFrentesToolBar',
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    agregarArchivo() {
      this.$emit('agregarArchivo');
    },
  },
};
</script>

<style lang="scss">

</style>
